import { render, staticRenderFns } from "./pabulum.vue?vue&type=template&id=7af42ad2&scoped=true&"
import script from "./pabulum.vue?vue&type=script&lang=js&"
export * from "./pabulum.vue?vue&type=script&lang=js&"
import style0 from "./pabulum.vue?vue&type=style&index=0&id=7af42ad2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af42ad2",
  null
  
)

export default component.exports